import { render, staticRenderFns } from "./TwoNoHo.vue?vue&type=template&id=18ec1bf4&scoped=true&"
import script from "./TwoNoHo.vue?vue&type=script&lang=js&"
export * from "./TwoNoHo.vue?vue&type=script&lang=js&"
import style0 from "./TwoNoHo.vue?vue&type=style&index=0&id=18ec1bf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ec1bf4",
  null
  
)

export default component.exports